/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Overview_DescriptionInputs */

const es_billing_overview_description = /** @type {(inputs: Billing_Overview_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan activo, período de facturación y gasto actual.`)
};

const en_billing_overview_description = /** @type {(inputs: Billing_Overview_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active plan, billing period and current spend.`)
};

/**
* | output |
* | --- |
* | "Active plan, billing period and current spend." |
*
* @param {Billing_Overview_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_overview_description = /** @type {((inputs?: Billing_Overview_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Overview_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_overview_description(inputs)
	return en_billing_overview_description(inputs)
});
export { billing_overview_description as "billing.overview.description" }